import { hasNoValue, hasValue } from "@/utils/Helpers";
import { nanoid } from "nanoid";
import { useState } from "react";
import { Field, FieldProps } from "react-final-form";
import "./CompareField.scss";
import FormFieldValues from "./FormFieldValues";

type CompareFieldProps = {
  prePrefix?: string;
  postPrefix?: string;
  ignoreCompare?: boolean;
};
const CompareField = <T,>(
  props: FieldProps<T, any, any> & CompareFieldProps
) => {
  const [key] = useState(nanoid);
  const prePrefix = props.prePrefix ? `${props.prePrefix}.` : "pre.";
  const postPrefix = props.postPrefix ? `${props.postPrefix}.` : "";

  const isPrefield = props.name.startsWith(prePrefix);
  const isPostfield = !isPrefield && props.name.startsWith(postPrefix);

  const nameBase = isPrefield
    ? props.name.substring(prePrefix.length)
    : props.name.substring(postPrefix.length);
  const preName = `${prePrefix}${nameBase}`;
  const postName = `${postPrefix}${nameBase}`;

  const field = <Field key={key} {...props} />;
  if (!props.ignoreCompare) {
    if (isPrefield || isPostfield) {
      return (
        <FormFieldValues names={[preName, postName]}>
          {([preValue, postValue]) => {
            // console.log(
            //   "CompareField",
            //   preName,
            //   props.name,
            //   preValue,
            //   postName,
            //   postValue
            // );
            let cls = "";
            if (_.isEqual(preValue, postValue)) {
              cls = "compare-field equal";
              // return <div className={`compare-field equal`}>{field}</div>;
            } else {
              // if (_.isEqual(preValue, postValue)) {
              //   return field;
              // }

              if (hasNoValue(preValue) && hasValue(postValue) && isPostfield) {
                cls = "compare-field add";
                // return <div className={`compare-field add`}>{field}</div>;
              }
              if (hasValue(preValue) && hasNoValue(postValue) && isPrefield) {
                cls = "compare-field remove";
                // return <div className={`compare-field remove`}>{field}</div>;
              }
              if (hasValue(preValue) && hasValue(postValue) && isPostfield) {
                cls = "compare-field update";
                // return <div className={`compare-field update`}>{field}</div>;
              }

              if (hasValue(preValue) && hasNoValue(postValue) && isPostfield) {
                cls = "compare-field update";
                // return <div className={`compare-field update`}>{field}</div>;
              }
            }

            return <div className={cls}>{field}</div>;
          }}
        </FormFieldValues>
      );
    }
  }

  return field;
};

export default CompareField;
